// extracted by mini-css-extract-plugin
module.exports = {"blogs-container":"Blogs_blogs-container__2DzsV","blogs-content":"Blogs_blogs-content__1W9qG","no-blogs":"Blogs_no-blogs__6wKbp"};